export const OPEN = 'Open'
export const CANCELED = 'Cancelled'
export const CLOSED = 'Closed'
